<template>
    <div class="work-schedule-marker" :class="itemClasses">
        <slot />
    </div>
</template>

<script lang="ts">
    import {WorkScheduleFulfillmentRequirement} from '@cquential/api';
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component
    export default class WorkScheduleMarker extends Vue {
        @Prop() public fulfillmentRequirement?: WorkScheduleFulfillmentRequirement;

        public get itemClasses(): Record<string, boolean> {
            return {
                'fulfillment-requirement-desired': this.fulfillmentRequirement === WorkScheduleFulfillmentRequirement.DESIRED,
                'fulfillment-requirement-extra': this.fulfillmentRequirement === WorkScheduleFulfillmentRequirement.EXTRA,
            };
        }
    }
</script>

<style lang="scss" scoped>
    .work-schedule-marker {
        &.fulfillment-requirement-desired {
            --marker-corner-color: var(--deployment-marker-evening-color);
        }

        &.fulfillment-requirement-extra {
            --marker-corner-color: var(--deployment-marker-other-color);
        }

        &.fulfillment-requirement-desired,
        &.fulfillment-requirement-extra {
            &::after {
                display: block;
                content: '';
                color: #333;
                box-shadow: none;
                background: linear-gradient(45deg, transparent var(--deployment-marker-visible-size), var(--marker-corner-color) var(--deployment-marker-visible-size));
                position: absolute;
                right: 0;
                top: 0;
                height: 50%;
                aspect-ratio: 1;
            }
        }
    }
</style>
